import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Reveal } from "./Reveal";

const API = process.env.REACT_APP_BACKEND_URL;

const inputCls =
  "w-full rounded-xl border border-white/15 bg-black/40 px-4 py-3 font-body text-sm text-white placeholder:text-white/30 focus:border-[#d4af37] focus:outline-none transition-colors duration-300";

export const ContactForm = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in your name, email, and message.");
      return;
    }
    setSending(true);
    try {
      const res = await fetch(`${API}/api/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error("Request failed");
      toast.success("Message sent! We'll get back to you shortly.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again or email us directly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section data-testid="contact-form-section" className="relative py-16 md:py-20">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-[#d4af37] text-center">Send a Message</p>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl font-medium tracking-tight text-white text-center">
            Write to us <span className="text-gold-gradient italic">directly.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <form onSubmit={submit} className="mt-10 rounded-3xl border border-[#bf953f]/25 bg-black/30 p-8 md:p-10 space-y-5" data-testid="contact-form">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <input data-testid="contact-name-input" className={inputCls} placeholder="Full name *" value={form.name} onChange={set("name")} />
              <input data-testid="contact-email-input" type="email" className={inputCls} placeholder="Email address *" value={form.email} onChange={set("email")} />
            </div>
            <input data-testid="contact-phone-input" className={inputCls} placeholder="Phone number (optional)" value={form.phone} onChange={set("phone")} />
            <textarea
              data-testid="contact-message-input"
              rows={5}
              className={inputCls}
              placeholder="How can we help your family? *"
              value={form.message}
              onChange={set("message")}
            />
            <button
              type="submit"
              disabled={sending}
              data-testid="contact-submit-btn"
              className="btn-sweep w-full inline-flex items-center justify-center gap-2 rounded-full bg-gold-metallic px-8 py-4 font-body text-sm font-semibold tracking-wide text-black disabled:opacity-60"
            >
              {sending ? "Sending..." : "Send Message"}
              <Send size={16} />
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
